// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"056d5c92","248":"da6bce47","278":"95236468","521":"e5f5a73c","702":"0ca6d068"}[chunkId] + ".chunk.js";
};